// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum ExemptionRegistrationMethod {
  Notification = "NOTIFICATION",
  VehicleRegisterSynchronization = "VEHICLE_REGISTER_SYNCHRONIZATION",
}
export default ExemptionRegistrationMethod;
